// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationToggle-module--button--m9y6r","icon":"NavigationToggle-module--icon--xrtMj","icon__close":"NavigationToggle-module--icon__close--2iZsQ"};